(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["form~index"],{

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/components/form/style/index.scss
var form_style = __webpack_require__(276);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/lodash/isRegExp.js
var isRegExp = __webpack_require__(206);
var isRegExp_default = /*#__PURE__*/__webpack_require__.n(isRegExp);

// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var warning = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/async-validator/dist-web/index.js
var dist_web = __webpack_require__(208);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(99);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./src/components/grid/Col.jsx
var Col = __webpack_require__(23);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(207);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./src/components/grid/Row.jsx + 1 modules
var Row = __webpack_require__(56);

// CONCATENATED MODULE: ./src/components/form/constants.jsx
var FIELD_META_PROP = 'data-__meta';
var FIELD_DATA_PROP = 'data-__field';
// EXTERNAL MODULE: ./src/utils/getTransitionProps.js
var getTransitionProps = __webpack_require__(22);

// EXTERNAL MODULE: ./src/utils/vnode.js
var utils_vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/icon/index.jsx
var components_icon = __webpack_require__(41);

// CONCATENATED MODULE: ./src/components/form/base-form-item.jsx

var _excluded = ["style", "id", "on"],
    _excluded2 = ["class", "style", "id", "on"];

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















function noop() {}

function intersperseSpace(list) {
  return list.reduce(function (current, item) {
    return [].concat(_toConsumableArray(current), [' ', item]);
  }, []).slice(1);
}

var FormItemProps = {
  id: vue_types["a" /* default */].string,
  htmlFor: vue_types["a" /* default */].string,
  prefixCls: vue_types["a" /* default */].string,
  label: vue_types["a" /* default */].any,
  labelCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  wrapperCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  help: vue_types["a" /* default */].any,
  extra: vue_types["a" /* default */].any,
  validateStatus: vue_types["a" /* default */].oneOf(['', 'success', 'warning', 'error', 'validating']),
  hasFeedback: vue_types["a" /* default */].bool,
  required: vue_types["a" /* default */].bool,
  colon: vue_types["a" /* default */].bool,
  fieldDecoratorId: vue_types["a" /* default */].string,
  fieldDecoratorOptions: vue_types["a" /* default */].object,
  selfUpdate: vue_types["a" /* default */].bool,
  labelAlign: vue_types["a" /* default */].oneOf(['left', 'right'])
};

function comeFromSlot() {
  var vnodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemVnode = arguments.length > 1 ? arguments[1] : undefined;
  var isSlot = false;

  for (var i = 0, len = vnodes.length; i < len; i++) {
    var vnode = vnodes[i];

    if (vnode && (vnode === itemVnode || vnode.$vnode === itemVnode)) {
      isSlot = true;
    } else {
      var componentOptions = vnode.componentOptions || vnode.$vnode && vnode.$vnode.componentOptions;
      var children = componentOptions ? componentOptions.children : vnode.$children;
      isSlot = comeFromSlot(children, itemVnode);
    }

    if (isSlot) {
      break;
    }
  }

  return isSlot;
}

/* harmony default export */ var base_form_item = ({
  name: 'AFormItem',
  __ANT_FORM_ITEM: true,
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])(FormItemProps, {
    hasFeedback: false
  }),
  provide: function provide() {
    return {
      isFormItemChildren: true
    };
  },
  inject: {
    isFormItemChildren: {
      default: false
    },
    FormContext: {
      default: function _default() {
        return {};
      }
    },
    decoratorFormProps: {
      default: function _default() {
        return {};
      }
    },
    collectFormItemContext: {
      default: function _default() {
        return noop;
      }
    },
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    return {
      helpShow: false
    };
  },
  computed: {
    itemSelfUpdate: function itemSelfUpdate() {
      return !!(this.selfUpdate === undefined ? this.FormContext.selfUpdate : this.selfUpdate);
    }
  },
  created: function created() {
    this.collectContext();
  },
  beforeUpdate: function beforeUpdate() {
    if (false) {}
  },
  beforeDestroy: function beforeDestroy() {
    this.collectFormItemContext(this.$vnode && this.$vnode.context, 'delete');
  },
  mounted: function mounted() {
    var _this$$props = this.$props,
        help = _this$$props.help,
        validateStatus = _this$$props.validateStatus;
    Object(warning["a" /* default */])(this.getControls(this.slotDefault, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
    Object(warning["a" /* default */])(!this.fieldDecoratorId, 'Form.Item', '`fieldDecoratorId` is deprecated. please use `v-decorator={id, options}` instead.');
  },
  methods: {
    collectContext: function collectContext() {
      if (this.FormContext.form && this.FormContext.form.templateContext) {
        var templateContext = this.FormContext.form.templateContext;
        var vnodes = Object.values(templateContext.$slots || {}).reduce(function (a, b) {
          return [].concat(_toConsumableArray(a), _toConsumableArray(b));
        }, []);
        var isSlot = comeFromSlot(vnodes, this.$vnode);
        Object(warning["a" /* default */])(!isSlot, 'You can not set FormItem from slot, please use slot-scope instead slot');
        var isSlotScope = false; // 进一步判断是否是通过slot-scope传递

        if (!isSlot && this.$vnode.context !== templateContext) {
          isSlotScope = comeFromSlot(this.$vnode.context.$children, templateContext.$vnode);
        }

        if (!isSlotScope && !isSlot) {
          this.collectFormItemContext(this.$vnode.context);
        }
      }
    },
    getHelpMessage: function getHelpMessage() {
      var help = Object(props_util["getComponentFromProp"])(this, 'help');
      var onlyControl = this.getOnlyControl();

      if (help === undefined && onlyControl) {
        var errors = this.getField().errors;

        if (errors) {
          return intersperseSpace(errors.map(function (e, index) {
            var node = null;

            if (Object(props_util["isValidElement"])(e)) {
              node = e;
            } else if (Object(props_util["isValidElement"])(e.message)) {
              node = e.message;
            }

            return node ? Object(utils_vnode["a" /* cloneElement */])(node, {
              key: index
            }) : e.message;
          }));
        } else {
          return '';
        }
      }

      return help;
    },
    getControls: function getControls() {
      var childrenArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var recursively = arguments.length > 1 ? arguments[1] : undefined;
      var controls = [];

      for (var i = 0; i < childrenArray.length; i++) {
        if (!recursively && controls.length > 0) {
          break;
        }

        var child = childrenArray[i];

        if (!child.tag && child.text.trim() === '') {
          continue;
        }

        if (Object(props_util["getSlotOptions"])(child).__ANT_FORM_ITEM) {
          continue;
        }

        var children = Object(props_util["getAllChildren"])(child);
        var attrs = child.data && child.data.attrs || {};

        if (FIELD_META_PROP in attrs) {
          // And means FIELD_DATA_PROP in child.props, too.
          controls.push(child);
        } else if (children) {
          controls = controls.concat(this.getControls(children, recursively));
        }
      }

      return controls;
    },
    getOnlyControl: function getOnlyControl() {
      var child = this.getControls(this.slotDefault, false)[0];
      return child !== undefined ? child : null;
    },
    getChildAttr: function getChildAttr(prop) {
      var child = this.getOnlyControl();
      var data = {};

      if (!child) {
        return undefined;
      }

      if (child.data) {
        data = child.data;
      } else if (child.$vnode && child.$vnode.data) {
        data = child.$vnode.data;
      }

      return data[prop] || data.attrs[prop];
    },
    getId: function getId() {
      return this.getChildAttr('id');
    },
    getMeta: function getMeta() {
      return this.getChildAttr(FIELD_META_PROP);
    },
    getField: function getField() {
      return this.getChildAttr(FIELD_DATA_PROP);
    },
    getValidateStatus: function getValidateStatus() {
      var onlyControl = this.getOnlyControl();

      if (!onlyControl) {
        return '';
      }

      var field = this.getField();

      if (field.validating) {
        return 'validating';
      }

      if (field.errors) {
        return 'error';
      }

      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;

      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
        return 'success';
      }

      return '';
    },
    // Resolve duplicated ids bug between different forms
    // https://github.com/ant-design/ant-design/issues/7351
    onLabelClick: function onLabelClick() {
      var id = this.id || this.getId();

      if (!id) {
        return;
      }

      var formItemNode = this.$el;
      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));

      if (control && control.focus) {
        control.focus();
      }
    },
    onHelpAnimEnd: function onHelpAnimEnd(_key, helpShow) {
      this.helpShow = helpShow;

      if (!helpShow) {
        this.$forceUpdate();
      }
    },
    isRequired: function isRequired() {
      var required = this.required;

      if (required !== undefined) {
        return required;
      }

      if (this.getOnlyControl()) {
        var meta = this.getMeta() || {};
        var validate = meta.validate || [];
        return validate.filter(function (item) {
          return !!item.rules;
        }).some(function (item) {
          return item.rules.some(function (rule) {
            return rule.required;
          });
        });
      }

      return false;
    },
    renderHelp: function renderHelp(prefixCls) {
      var _this = this;

      var h = this.$createElement;
      var help = this.getHelpMessage();
      var children = help ? h("div", {
        "class": "".concat(prefixCls, "-explain"),
        key: "help"
      }, [help]) : null;

      if (children) {
        this.helpShow = !!children;
      } // const transitionProps = getTransitionProps('fade', {
      //   afterEnter: () => this.onHelpAnimEnd('help', true),
      //   afterLeave: () => this.onHelpAnimEnd('help', false),
      // });


      var transitionProps = {
        on: {
          afterEnter: function afterEnter() {
            return _this.onHelpAnimEnd('help', true);
          },
          afterLeave: function afterLeave() {
            return _this.onHelpAnimEnd('help', false);
          }
        }
      };
      return h("transition", babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          name: 'fade'
        }
      }, transitionProps, {
        key: "help"
      }]), [children]);
    },
    renderExtra: function renderExtra(prefixCls) {
      var h = this.$createElement;
      var extra = Object(props_util["getComponentFromProp"])(this, 'extra');
      return extra ? h("div", {
        "class": "".concat(prefixCls, "-extra")
      }, [extra]) : null;
    },
    renderValidateWrapper: function renderValidateWrapper(prefixCls, c1, c2, c3) {
      var h = this.$createElement;
      var props = this.$props;
      var onlyControl = this.getOnlyControl;
      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
      var classes = "".concat(prefixCls, "-item-control");

      if (validateStatus) {
        classes = external_classnames_default()("".concat(prefixCls, "-item-control"), {
          'has-feedback': validateStatus && props.hasFeedback,
          'has-success': validateStatus === 'success',
          'has-warning': validateStatus === 'warning',
          'has-error': validateStatus === 'error',
          'is-validating': validateStatus === 'validating'
        });
      }

      var iconType = '';

      switch (validateStatus) {
        case 'success':
          iconType = 'check-circle';
          break;

        case 'warning':
          iconType = 'exclamation-circle';
          break;

        case 'error':
          iconType = 'close-circle';
          break;

        case 'validating':
          iconType = 'loading';
          break;

        default:
          iconType = '';
          break;
      }

      var icon = props.hasFeedback && iconType ? h("span", {
        "class": "".concat(prefixCls, "-item-children-icon")
      }, [h(components_icon["default"], {
        attrs: {
          type: iconType,
          theme: iconType === 'loading' ? 'outlined' : 'filled'
        }
      })]) : null;
      return h("div", {
        "class": classes
      }, [h("span", {
        "class": "".concat(prefixCls, "-item-children")
      }, [c1, icon]), c2, c3]);
    },
    renderWrapper: function renderWrapper(prefixCls, children) {
      var h = this.$createElement;

      var _ref = this.isFormItemChildren ? {} : this.FormContext,
          contextWrapperCol = _ref.wrapperCol;

      var wrapperCol = this.wrapperCol;
      var mergedWrapperCol = wrapperCol || contextWrapperCol || {};

      var style = mergedWrapperCol.style,
          id = mergedWrapperCol.id,
          on = mergedWrapperCol.on,
          restProps = _objectWithoutProperties(mergedWrapperCol, _excluded);

      var className = external_classnames_default()("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.class);
      var colProps = {
        props: restProps,
        class: className,
        key: 'wrapper',
        style: style,
        id: id,
        on: on
      };
      return h(Col["b" /* default */], colProps, [children]);
    },
    renderLabel: function renderLabel(prefixCls) {
      var _classNames;

      var h = this.$createElement;
      var _this$FormContext = this.FormContext,
          vertical = _this$FormContext.vertical,
          contextLabelAlign = _this$FormContext.labelAlign,
          contextLabelCol = _this$FormContext.labelCol,
          contextColon = _this$FormContext.colon;
      var labelAlign = this.labelAlign,
          labelCol = this.labelCol,
          colon = this.colon,
          id = this.id,
          htmlFor = this.htmlFor;
      var label = Object(props_util["getComponentFromProp"])(this, 'label');
      var required = this.isRequired();
      var mergedLabelCol = labelCol || contextLabelCol || {};
      var mergedLabelAlign = labelAlign || contextLabelAlign;
      var labelClsBasic = "".concat(prefixCls, "-item-label");
      var labelColClassName = external_classnames_default()(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.class);

      var labelColClass = mergedLabelCol.class,
          labelColStyle = mergedLabelCol.style,
          labelColId = mergedLabelCol.id,
          on = mergedLabelCol.on,
          restProps = _objectWithoutProperties(mergedLabelCol, _excluded2);

      var labelChildren = label; // Keep label is original where there should have no colon

      var computedColon = colon === true || contextColon !== false && colon !== false;
      var haveColon = computedColon && !vertical; // Remove duplicated user input colon

      if (haveColon && typeof label === 'string' && label.trim() !== '') {
        labelChildren = label.replace(/[：:]\s*$/, '');
      }

      var labelClassName = external_classnames_default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
      var colProps = {
        props: restProps,
        class: labelColClassName,
        key: 'label',
        style: labelColStyle,
        id: labelColId,
        on: on
      };
      return label ? h(Col["b" /* default */], colProps, [h("label", {
        attrs: {
          "for": htmlFor || id || this.getId(),
          title: typeof label === 'string' ? label : ''
        },
        "class": labelClassName,
        on: {
          "click": this.onLabelClick
        }
      }, [labelChildren])]) : null;
    },
    renderChildren: function renderChildren(prefixCls) {
      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, this.slotDefault, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
    },
    renderFormItem: function renderFormItem() {
      var _itemClassName;

      var h = this.$createElement;
      var customizePrefixCls = this.$props.prefixCls;
      var getPrefixCls = this.configProvider.getPrefixCls;
      var prefixCls = getPrefixCls('form', customizePrefixCls);
      var children = this.renderChildren(prefixCls);
      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), this.helpShow), _itemClassName);
      return h(Row["a" /* default */], {
        "class": external_classnames_default()(itemClassName),
        key: "row"
      }, [children]);
    },
    decoratorOption: function decoratorOption(vnode) {
      if (vnode.data && vnode.data.directives) {
        var directive = find_default()(vnode.data.directives, ['name', 'decorator']);
        Object(warning["a" /* default */])(!directive || directive && Array.isArray(directive.value), 'Form', "Invalid directive: type check failed for directive \"decorator\". Expected Array, got ".concat(_typeof(directive ? directive.value : directive), ". At ").concat(vnode.tag, "."));
        return directive ? directive.value : null;
      } else {
        return null;
      }
    },
    decoratorChildren: function decoratorChildren(vnodes) {
      var FormContext = this.FormContext;
      var getFieldDecorator = FormContext.form.getFieldDecorator;

      for (var i = 0, len = vnodes.length; i < len; i++) {
        var vnode = vnodes[i];

        if (Object(props_util["getSlotOptions"])(vnode).__ANT_FORM_ITEM) {
          break;
        }

        if (vnode.children) {
          vnode.children = this.decoratorChildren(Object(utils_vnode["b" /* cloneVNodes */])(vnode.children));
        } else if (vnode.componentOptions && vnode.componentOptions.children) {
          vnode.componentOptions.children = this.decoratorChildren(Object(utils_vnode["b" /* cloneVNodes */])(vnode.componentOptions.children));
        }

        var option = this.decoratorOption(vnode);

        if (option && option[0]) {
          vnodes[i] = getFieldDecorator(option[0], option[1], this)(vnode);
        }
      }

      return vnodes;
    }
  },
  render: function render() {
    var $slots = this.$slots,
        decoratorFormProps = this.decoratorFormProps,
        fieldDecoratorId = this.fieldDecoratorId,
        _this$fieldDecoratorO = this.fieldDecoratorOptions,
        fieldDecoratorOptions = _this$fieldDecoratorO === void 0 ? {} : _this$fieldDecoratorO,
        FormContext = this.FormContext;
    var child = Object(props_util["filterEmpty"])($slots.default || []);

    if (decoratorFormProps.form && fieldDecoratorId && child.length) {
      var getFieldDecorator = decoratorFormProps.form.getFieldDecorator;
      child[0] = getFieldDecorator(fieldDecoratorId, fieldDecoratorOptions, this)(child[0]);
      Object(warning["a" /* default */])(!(child.length > 1), 'Form', '`autoFormCreate` just `decorator` then first children. but you can use JSX to support multiple children');
      this.slotDefault = child;
    } else if (FormContext.form) {
      child = Object(utils_vnode["b" /* cloneVNodes */])(child);
      this.slotDefault = this.decoratorChildren(child);
    } else {
      this.slotDefault = child;
    }

    return this.renderFormItem();
  }
});
// CONCATENATED MODULE: ./src/components/form/form-item.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { form_item_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function form_item_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function form_item_noop() {}

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  var keyArr = path.split('.');
  var i = 0;

  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];

    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }

      break;
    }
  }

  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}

var form_item_FormItemProps = {
  id: vue_types["a" /* default */].string,
  htmlFor: vue_types["a" /* default */].string,
  prefixCls: vue_types["a" /* default */].string,
  label: vue_types["a" /* default */].any,
  help: vue_types["a" /* default */].any,
  extra: vue_types["a" /* default */].any,
  labelCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  wrapperCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  hasFeedback: vue_types["a" /* default */].bool,
  colon: vue_types["a" /* default */].bool,
  labelAlign: vue_types["a" /* default */].oneOf(['left', 'right']),
  prop: vue_types["a" /* default */].string,
  rules: vue_types["a" /* default */].oneOfType([Array, Object]),
  autoLink: vue_types["a" /* default */].bool,
  required: vue_types["a" /* default */].bool,
  isWatch: vue_types["a" /* default */].bool,
  // 监听是否联动属性
  validateStatus: vue_types["a" /* default */].oneOf(['', 'success', 'warning', 'error', 'validating']),
  suffix: vue_types["a" /* default */].any
};
/* harmony default export */ var form_item = ({
  name: 'MegFormItem',
  __ANT_NEW_FORM_ITEM: true,
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])(form_item_FormItemProps, {
    hasFeedback: false,
    autoLink: true
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    },
    FormContext: {
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      validateState: this.validateStatus,
      validateMessage: '',
      validateDisabled: false,
      validator: {}
    };
  },
  computed: {
    fieldValue: function fieldValue() {
      var model = this.FormContext.model;

      if (!model || !this.prop) {
        return;
      }

      var path = this.prop;

      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/g, '.');
      }

      return getPropByPath(model, path, true).v;
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }

          return true;
        });
      }

      return isRequired;
    }
  },
  watch: {
    validateStatus: function validateStatus(val) {
      this.validateState = val;
    },
    fieldValue: function fieldValue() {
      this.isWatch && this.validate('', function () {});
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      var addField = this.FormContext.addField;
      addField && addField(this);
      this.initialValue = cloneDeep_default()(this.fieldValue);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var removeField = this.FormContext.removeField;
    removeField && removeField(this);
  },
  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : form_item_noop;
      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);

      if (!rules || rules.length === 0) {
        callback();
        return true;
      }

      this.validateState = 'validating';
      var descriptor = {};

      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }

      descriptor[this.prop] = rules;
      var validator = new dist_web["a" /* default */](descriptor);

      if (this.FormContext && this.FormContext.validateMessages) {
        validator.messages(this.FormContext.validateMessages);
      }

      var model = {};
      model[this.prop] = this.fieldValue;
      validator.validate(model, {
        firstFields: true
      }, function (errors, invalidFields) {
        _this.validateState = errors ? 'error' : 'success';
        _this.validateMessage = errors ? errors[0].message : '';
        callback(_this.validateMessage, invalidFields);
        _this.FormContext && _this.FormContext.$emit && _this.FormContext.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
      });
    },
    getRules: function getRules() {
      var formRules = this.FormContext.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? {
        required: !!this.required,
        trigger: 'change'
      } : [];
      var prop = getPropByPath(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();
      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;

        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return _objectSpread({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      var _this2 = this;

      this.validateState = '';
      this.validateMessage = '';
      var model = this.FormContext.model || {};
      var value = this.fieldValue;
      var path = this.prop;

      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = getPropByPath(model, path, true);
      this.validateDisabled = true;

      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      } // reset validateDisabled after onFieldChange triggered


      this.$nextTick(function () {
        _this2.validateDisabled = false;
      });
    },
    renderSuffix: function renderSuffix() {
      var h = this.$createElement;

      if (this.suffix) {
        return h("div", {
          "class": "meg-form-item-suffix"
        }, [this.suffix]);
      } // 兼容vue的用法slots


      if (this.$slots.suffix) {
        return h("div", {
          "class": "meg-form-item-suffix"
        }, [this.$slots.suffix]);
      }

      return null;
    }
  },
  render: function render() {
    var _this3 = this;

    var h = arguments[0];
    var $slots = this.$slots,
        $scopedSlots = this.$scopedSlots;
    var props = Object(props_util["getOptionProps"])(this);
    var label = Object(props_util["getComponentFromProp"])(this, 'label');
    var extra = Object(props_util["getComponentFromProp"])(this, 'extra');
    var help = Object(props_util["getComponentFromProp"])(this, 'help');
    var formProps = {
      props: _objectSpread(_objectSpread({}, props), {}, {
        label: label,
        extra: extra,
        validateStatus: this.validateState,
        help: this.validateMessage || help,
        required: this.isRequired || props.required
      })
    };
    var children = Object(props_util["filterEmpty"])($scopedSlots.default ? $scopedSlots.default() : $slots.default);
    var firstChildren = children[0];

    if (this.prop && this.autoLink && Object(props_util["isValidElement"])(firstChildren)) {
      var originalEvents = Object(props_util["getEvents"])(firstChildren);
      var originalBlur = originalEvents.blur;
      var originalChange = originalEvents.change;
      firstChildren = Object(utils_vnode["a" /* cloneElement */])(firstChildren, {
        on: {
          blur: function blur() {
            originalBlur && originalBlur.apply(void 0, arguments);

            _this3.onFieldBlur();
          },
          change: function change() {
            if (Array.isArray(originalChange)) {
              for (var i = 0, l = originalChange.length; i < l; i++) {
                originalChange[i].apply(originalChange, arguments);
              }
            } else if (originalChange) {
              originalChange.apply(void 0, arguments);
            }

            _this3.onFieldChange();
          }
        }
      });
    }

    return h(base_form_item, formProps, [firstChildren, children.slice(1), this.renderSuffix()]);
  }
});
// CONCATENATED MODULE: ./src/components/form/form.jsx
function form_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var FormProps = {
  layout: vue_types["a" /* default */].oneOf(['horizontal', 'inline', 'vertical']),
  labelCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  wrapperCol: vue_types["a" /* default */].shape(Col["a" /* ColProps */]).loose,
  colon: vue_types["a" /* default */].bool,
  labelAlign: vue_types["a" /* default */].oneOf(['left', 'right']),
  prefixCls: vue_types["a" /* default */].string,
  hideRequiredMark: vue_types["a" /* default */].bool,
  model: vue_types["a" /* default */].object,
  rules: vue_types["a" /* default */].object,
  validateMessages: vue_types["a" /* default */].any,
  validateOnRuleChange: vue_types["a" /* default */].bool
};
var ValidationRule = {
  /** validation error message */
  message: vue_types["a" /* default */].string,

  /** built-in validation type, available options: https://github.com/yiminghe/async-validator#type */
  type: vue_types["a" /* default */].string,

  /** indicates whether field is required */
  required: vue_types["a" /* default */].boolean,

  /** treat required fields that only contain whitespace as errors */
  whitespace: vue_types["a" /* default */].boolean,

  /** validate the exact length of a field */
  len: vue_types["a" /* default */].number,

  /** validate the min length of a field */
  min: vue_types["a" /* default */].number,

  /** validate the max length of a field */
  max: vue_types["a" /* default */].number,

  /** validate the value from a list of possible values */
  enum: vue_types["a" /* default */].oneOfType([String, vue_types["a" /* default */].arrayOf(String)]),

  /** validate from a regular expression */
  pattern: vue_types["a" /* default */].custom(isRegExp_default.a),

  /** transform a value before validation */
  transform: vue_types["a" /* default */].func,

  /** custom validate function (Note: callback must be called) */
  validator: vue_types["a" /* default */].func
};
var Form = {
  name: 'MegForm',
  props: Object(props_util["initDefaultProps"])(FormProps, {
    layout: 'horizontal',
    hideRequiredMark: false,
    colon: true
  }),
  Item: form_item,
  created: function created() {
    this.fields = [];
  },
  provide: function provide() {
    return {
      FormContext: this
    };
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  watch: {
    rules: function rules() {
      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  computed: {
    vertical: function vertical() {
      return this.layout === 'vertical';
    }
  },
  methods: {
    addField: function addField(field) {
      if (field) {
        this.fields.push(field);
      }
    },
    removeField: function removeField(field) {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1);
      }
    },
    onSubmit: function onSubmit(e) {
      if (!Object(props_util["getListeners"])(this).submit) {
        e.preventDefault();
      } else {
        this.$emit('submit', e);
      }
    },
    resetFields: function resetFields() {
      if (!this.model) {
        Object(warning["a" /* default */])(false, 'FormModel', 'model is required for resetFields to work.');
        return;
      }

      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
        return props === field.prop;
      }) : this.fields.filter(function (field) {
        return props.indexOf(field.prop) > -1;
      }) : this.fields;
      fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this = this;

      if (!this.model) {
        Object(warning["a" /* default */])(false, 'FormModel', 'model is required for resetFields to work.');
        return;
      }

      var promise; // if no callback, return promise

      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0; // 如果需要验证的fields为空，调用验证时立刻返回callback

      if (this.fields.length === 0 && callback) {
        callback(true);
      }

      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }

          invalidFields = Object.assign({}, invalidFields, field);

          if (typeof callback === 'function' && ++count === _this.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(props, cb) {
      props = [].concat(props);
      var fields = this.fields.filter(function (field) {
        return props.indexOf(field.prop) !== -1;
      });

      if (!fields.length) {
        Object(warning["a" /* default */])(false, 'FormModel', 'please pass correct props!');
        return;
      }

      fields.forEach(function (field) {
        field.validate('', cb);
      });
    }
  },
  render: function render() {
    var _classNames;

    var h = arguments[0];
    var customizePrefixCls = this.prefixCls,
        hideRequiredMark = this.hideRequiredMark,
        layout = this.layout,
        onSubmit = this.onSubmit,
        $slots = this.$slots;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    var formClassName = external_classnames_default()(prefixCls, (_classNames = {}, form_defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), form_defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), form_defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), form_defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames));
    return h("form", {
      on: {
        "submit": onSubmit
      },
      "class": formClassName
    }, [$slots.default]);
  }
};
/* harmony default export */ var form_form = (Form);
// CONCATENATED MODULE: ./src/components/form/index.jsx
// 样式文件
// import './style/index.scss';


form_form.install = function (Vue) {
  Vue.component(form_form.name, form_form);
  Vue.component(form_form.Item.name, form_form.Item);
};

/* harmony default export */ var components_form = __webpack_exports__["default"] = (form_form);

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

}]);